import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { success_retrieve_tenant_information } from '../reducers/no_auth_tenant/retrieve_tenant_information_Slice';
import * as app_consts from "../utils/app_consts";
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'; // Ensure using react-router-dom
import LayoutNoSidebar from "../layout/Index-nosidebar";
import TenantAuth from '../pages/auth/TenantAuth';
import { getFirstPathAfterCom, getTenantURLPrefix } from '../utils/Utils';
import TenantSendOTP from '../pages/auth/TenantSendOTP';
import VerifyTenantOTP from '../pages/auth/VerifyTenantOTP';
import WebStoreAuth from '../pages/auth/WebStoreAuth';
import WebStoreSentOTP from '../pages/auth/WebStoreSentOTP';
import WebStoreVerifyOTP from '../pages/auth/WebStoreVerifyOTP';



// Load First 
const currentUrl = window.location.href;
const main_tenant_url_prefix = getFirstPathAfterCom(currentUrl);

const NoAuthTenants = () => {
 const dispatch = useDispatch();
 const navigate = useNavigate();
 const [tenant_info, setTenantInfo] = useState(null);

 // Load tenant info from local storage
 useEffect(() => {
  const storedTenant = localStorage.getItem("dashboard_tenant");

  if (storedTenant)
  {
   const tenant_data = JSON.parse(storedTenant);
   dispatch(success_retrieve_tenant_information(tenant_data));
  }
 }, [dispatch]);

 // Get tenant information from Redux store
 const tenant_information = useSelector((state) => state.retrieve_tenant_information.retrieve_tenant_information);



 // Update state and navigate when tenant information is available
 useEffect(() => {
  if (tenant_information?.status === app_consts.SUCCESS && (tenant_information?.data?.url_prefix !== main_tenant_url_prefix))
  {
   localStorage?.clear();
   window.location.assign(`/${main_tenant_url_prefix}`);
  }
  else
  {
   setTenantInfo(tenant_information.data);
  }
 }, [tenant_information, navigate]);

 return (
  <>
   {tenant_info && (
    <Routes>
     <Route path="/" element={<LayoutNoSidebar />}>
      <Route path={`/${tenant_info.url_prefix}/auth`} element={<TenantAuth tenant_info={tenant_info} />} />
      <Route path={`/${tenant_info.url_prefix}/auth/send_otp`} element={<TenantSendOTP tenant_info={tenant_info} />} />
      <Route path={`/${tenant_info.url_prefix}/auth/verify_otp`} element={<VerifyTenantOTP tenant_info={tenant_info} />} />

      <Route path={`/${tenant_info.url_prefix}/webstore/auth`} element={<WebStoreAuth tenant_info={tenant_info} />} />
      <Route path={`/${tenant_info.url_prefix}/webstore/auth/send_otp`} element={<WebStoreSentOTP tenant_info={tenant_info} />} />
      <Route path={`/${tenant_info.url_prefix}/webstore/auth/verify_otp`} element={<WebStoreVerifyOTP tenant_info={tenant_info} />} />


      <Route path="*" element={<Navigate to={`/${tenant_info.url_prefix}/auth`} replace />} />
      <Route path="" element={<Navigate to={`/${tenant_info.url_prefix}/auth`} replace />} />


     </Route>
    </Routes>
   )}
  </>
 );
};

export default NoAuthTenants;
